import { render } from "./aboutUs.vue?vue&type=template&id=d1394386&scoped=true"
const script = {}

import "./aboutUs.vue?vue&type=style&index=0&id=d1394386&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1394386"]])

export default __exports__